import React, { useCallback } from 'react';
import styled from 'styled-components';

import { SearchInput } from 'src/presentation/components/agent_desktop_components';

const Search: React.FC<{
  dataAid?: string;
  disableSearch?: boolean;
  onChangeSearchFilter: any;
  searchInputControl?: JSX.Element;
  searchPlaceholder: string;
  searchString?: string;
  setInputRef?: any;
  setSearchRef?: any;
}> = props => {
  const {
    dataAid,
    disableSearch,
    onChangeSearchFilter,
    searchInputControl: searchInput,
    searchPlaceholder,
    searchString,
    setInputRef,
    setSearchRef,
  } = props;

  const onChange = useCallback(evt => onChangeSearchFilter(evt.target.value), [onChangeSearchFilter]);

  const defaultSearchInput = (
    <StyledSearchInput
      data-aid={`${dataAid}-header-searchInput`}
      disabled={disableSearch}
      onChange={onChange}
      initialValue={searchString}
      setInputRef={setInputRef}
      setSearchRef={setSearchRef}
      placeholder={searchPlaceholder}
    />
  );

  const renderSearchInput = searchInput || defaultSearchInput;

  return <>{renderSearchInput}</>;
};

const StyledSearchInput = styled(SearchInput)`
  flex-shrink: 1;
  margin-right: 12px;
  min-width: auto;
  width: 350px;
`;

export default Search;
